import { render, staticRenderFns } from "./Line.vue?vue&type=template&id=2d25969d&"
import script from "./Line.vue?vue&type=script&lang=js&"
export * from "./Line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d25969d')) {
      api.createRecord('2d25969d', component.options)
    } else {
      api.reload('2d25969d', component.options)
    }
    module.hot.accept("./Line.vue?vue&type=template&id=2d25969d&", function () {
      api.rerender('2d25969d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/Line.vue"
export default component.exports